/**
 * C 端借款人登录 / 注册。
 *
 * 与 B 端 LOS（Loan Officer）区分 event name：
 * - 本应用（borrower）：AUTH_BORROWER_LOGIN / AUTH_BORROWER_SIGNUP
 * - LOS（loan officer）：AUTH_LOGIN / AUTH_SIGNUP（保持原名）
 *
 * 代码仍两层：STATSIG.AUTH.LOGIN → 控制台 AUTH_BORROWER_LOGIN
 *
 * PreApp 漏斗：
 * - Save progress 开户成功 → AUTH_BORROWER_SIGNUP（source=preapp|…）
 * - 「Sign in」→ /services/signin?source=preapp → 成功打 AUTH_BORROWER_LOGIN
 */
export enum AuthEvent {
    /**
     * 借款人登录成功。
     * value 与 metadata.type 相同：password|email_code|google|apple|…
     * 属性 source=preapp|signin|bare|…
     */
    LOGIN = 'AUTH_BORROWER_LOGIN',
    /**
     * 借款人注册 / 开户成功。
     * value 与 metadata.customer_id 相同（组织 id）
     * 属性 source=preapp|preapp_marketplace|preapp_verify_signup|signup|…
     */
    SIGNUP = 'AUTH_BORROWER_SIGNUP',
}

/** 从 URL 读埋点 source，缺省为 fallback。 */
export function getAuthSource(fallback = 'signin'): string {
    if (typeof window === 'undefined') return fallback
    try {
        return new URLSearchParams(window.location.search).get('source') || fallback
    } catch {
        return fallback
    }
}
